import { ComponentProps } from "react";

export function AirportStory(props: ComponentProps<"svg">) {
    return (
        <svg {...props} width="40" height="40" viewBox="0 0 40 40">
            <path d="M36 26.1V22.8L22.4 14.55V5.475C22.4 4.1055 21.328 3 20 3C18.672 3 17.6 4.1055 17.6 5.475V14.55L4 22.8V26.1L17.6 21.975V31.05L13.6 33.525V36L20 34.35L26.4 36V33.525L22.4 31.05V21.975L36 26.1Z" />
        </svg>
    );
}
